import FormBody from 'pages/Reports/sections/Upload/FormBody/FormBody';

export default FormBody;
